import script from "./ConfirmYourRefinanceDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmYourRefinanceDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmYourRefinanceDetailsModal.vue?vue&type=style&index=0&id=62420988&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62420988"]])

export default __exports__